import { useMemo } from 'react'
import { plainToInstance } from 'class-transformer'
import { Player } from '@ppwr/poker'
import { useStore } from '../../../models'

export const usePokerInfo = () => {
  const {
    game: { seatedPlayersWithSeatedObserver }
  } = useStore()

  const players = useMemo(
    () => seatedPlayersWithSeatedObserver?.map((player) => plainToInstance(Player, player)) ?? [],
    [seatedPlayersWithSeatedObserver]
  )

  return {
    players
  }
}
